export default "__VITE_ASSET__CSQo58aO__"